import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import About from "./components/About";
import Tours from "./components/Tours";
import ImportantInfo from "./components/ImportantInfo";
import Gallery from "./components/Gallery";
import Differentiators from "./components/Differentiators";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import BackToTop from "./components/BackToTop";

function App() {
    return (
        <LanguageProvider>
            <div className="App" data-testid="app-root">
                <Header />
                <main>
                    <Hero />
                    <TrustStrip />
                    <About />
                    <Tours />
                    <ImportantInfo />
                    <Gallery />
                    <Differentiators />
                    <Testimonials />
                    <Contact />
                </main>
                <Footer />
                <FloatingWhatsApp />
                <BackToTop />
            </div>
        </LanguageProvider>
    );
}

export default App;
